import { floodlightTrackPage } from '~/utils/gtm-events.js';

export default ({ app }, inject) => {
  // Set the function directly on the context.app object
  app.router.afterEach((to, from) => {
    floodlightTrackPage(app.$gtm, to.path);
  });
};
